module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('ModalBase', {
    attrs: {
      "with-content": true
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('h1', [_vm._v("Edit Ladder")]), _vm._v(" "), _c('section', [_c('label', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Fixed:")])]), _vm._v(" "), _c('label', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.fixed),
      callback: function($$v) {
        _vm.fixed = $$v
      },
      expression: "fixed"
    }
  })], 1)]), _vm._v(" "), _c('section', [_c('label', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("X:")])]), _vm._v(" "), _c('label', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.x),
      callback: function($$v) {
        _vm.x = $$v
      },
      expression: "x"
    }
  })], 1)]), _vm._v(" "), _c('section', [_c('label', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Top:")])]), _vm._v(" "), _c('label', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.top),
      callback: function($$v) {
        _vm.top = $$v
      },
      expression: "top"
    }
  })], 1)]), _vm._v(" "), _c('section', [_c('label', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Bottom:")])]), _vm._v(" "), _c('label', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.bottom),
      callback: function($$v) {
        _vm.bottom = $$v
      },
      expression: "bottom"
    }
  })], 1)]), _vm._v(" "), _c('section', [_c('label', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Top Pawl:")])]), _vm._v(" "), _c('label', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.topPawl),
      callback: function($$v) {
        _vm.topPawl = $$v
      },
      expression: "topPawl"
    }
  })], 1)]), _vm._v(" "), _c('section', [_c('label', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Bottom Pawl:")])]), _vm._v(" "), _c('label', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.bottomPawl),
      callback: function($$v) {
        _vm.bottomPawl = $$v
      },
      expression: "bottomPawl"
    }
  })], 1)]), _vm._v(" "), _c('section', [_c('label', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Pawl Interval:")])]), _vm._v(" "), _c('label', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.pawlInterval),
      callback: function($$v) {
        _vm.pawlInterval = $$v
      },
      expression: "pawlInterval"
    }
  })], 1)]), _vm._v(" "), _c('footer', {
    staticStyle: {
      "float": "right",
      "margin-top": "5px"
    }
  }, [_c('ClientColorButton', {
    on: {
      "click": _vm.validate
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.ok))]), _vm._v(" "), _c('ClientColorButton', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-194b1c9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/edit_board_ladder.vue
// module id = 3043
// module chunks = 0